import { useState } from "react";
import { CalculadoraIsencaoInputCard } from "./components/CalculadoraIsencaoInputCard";
import { CalculadoraIsencaoResponse } from "./components/CalculadoraIsencaoResponse";
import { IsencaoIRResultType } from "./calculadora-isencao-ir";

export default function CalculadoraIsencaoIR() {
  const [results, setResults] = useState<IsencaoIRResultType | null>(null);

  return (
    <>
      <CalculadoraIsencaoInputCard setResults={setResults} />
      {results && <CalculadoraIsencaoResponse results={results} />}
    </>
  );
}